import { ArrowUpIcon } from '@heroicons/react/20/solid';
import { ArrowUpCircleIcon } from '@heroicons/react/24/outline';
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
const BackToTopButton = () => {
	const location = useLocation();
	const [isVisible, setIsVisible] = useState(false);
	const navigate = useNavigate();
	// Toggle visibility based on scroll position
	const toggleVisibility = () => {
		if (window.scrollY >= 300) {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	};

	// Scroll to the top of the page
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
		if (window.tm) window.tm.event('click', { type: 'scroll-to-top', location: location.pathname });
		navigate(location.pathname);
	};

	useEffect(() => {
		// Add scroll event listener
		document.addEventListener('scroll', toggleVisibility);

		// Remove the event listener when the component is unmounted
		return () => {
			document.removeEventListener('scroll', toggleVisibility);
		};
	}, []);

	return (
		<div className='scroll-to-top'>
			{isVisible && (
				<div
					onClick={scrollToTop}
					className='text-white fixed bottom-0 font-bold right-0 bg-primary hover:bg-secondary p-3 cursor-pointer'
				>
					{/* Your icon or text to represent "Back to Top" */}
					<span>
						<ArrowUpIcon className='h-5 w-5' />
					</span>
				</div>
			)}
		</div>
	);
};

export default BackToTopButton;
